<template>
    <div class="cv-mx-auto cv-flex cv-flex-col cv-h-screen cv-overflow-hidden">
        <!-- <div class="cv-w-full cv-px-4 cv-flex cv-items-center cv-justify-between cv-h-12"></div> -->
        <div class="cv-overflow-y-auto cv-flex-1 cv-relative">
            <div id="container" class="cv-mb-4 cv-w-full cv-h-auto"></div>
            <div id="container1"></div>
            <!-- <div class="cv-space-x-4">
                <button @click="reload">reload</button>
                <button @click="unmount">unmount all</button>
            </div> -->
        </div>
    </div>
</template>
<script>
    import { render, setConfig, unmount as unmountVideo } from '@custouch/resource-video'
    import '@custouch/resource-video/global/dist/style.css'
    import { UAID } from '@/configs/constants'
    let instance
    setConfig({ appId: window.env.VUE_APP_APP_ID })
    export default {
        props: ['options', 'title'],
        mounted() {
            // 渲染 source 可以为外部链接/观看链接/hashId
            instance = render('#container', {
                aspectRatio: "16:9",
                allowSame: true,
                viewParams: {
                    title: this.title,
                    uaId: UAID
                },
                ...this.options
            })
    
            // long height
            // https://download.beta.custouch.com/download/videoviewer/c940fad06de14611
            // render('#container1', { source: 'https://download.beta.custouch.com/download/videoviewer/5359dce5c6d56c3d' })
    
            // 通过实例卸载
            // instance.unmount()
        }
    }
</script>